import React from "react";
import "./styles.css";

const testimonials = [
  {
    type: "student",
    name: "Ananya R.",
    role: "Grade 10 Student",
    initials: "AR",
    rating: 5,
    quote: "My math scores improved dramatically after just one month with Ms. Priya. She explains concepts in a way that finally makes sense to me!"
  },
  {
    type: "student",
    name: "Vijay P.",
    role: "Grade 12 Student",
    initials: "VP",
    rating: 5,
    quote: "The instant feedback on my physics solutions helped me correct my mistakes immediately. It's like having a tutor available 24/7!"
  },
  {
    type: "student",
    name: "Kiran S.",
    role: "Grade 11 Student",
    initials: "KS",
    rating: 5,
    quote: "I used to struggle with chemistry, but Dr. Sharma's teaching style and the practice questions really helped me understand complex reactions."
  },
  {
    type: "parent",
    name: "Priya Sharma",
    role: "Mother of 10th grader",
    initials: "PS",
    rating: 5,
    quote: "My son's grades improved dramatically in just 2 months. The personalized approach really made the difference."
  },
  {
    type: "parent",
    name: "Rajiv Kumar",
    role: "Father of 12th grader",
    initials: "RK",
    rating: 5,
    quote: "The detailed progress reports help me understand exactly where my daughter needs support. It's like having a tutor and academic counselor in one."
  },
  {
    type: "parent",
    name: "Meena Patel",
    role: "Mother of 8th grader",
    initials: "MP",
    rating: 5,
    quote: "As a working parent, I couldn't monitor my child's studies closely. Chanakya's insights have helped me stay connected with my son's academic progress."
  }
];

const StarRating = ({ rating }) => {
  return (
    <div className="star-rating">
      {[...Array(5)].map((_, index) => (
        <svg 
          key={index} 
          width="16" 
          height="16" 
          viewBox="0 0 24 24" 
          fill={index < rating ? "#FF4A00" : "#E2E8F0"} 
          xmlns="http://www.w3.org/2000/svg"
          className="star-icon"
        >
          <path d="M12 2l2.4 7.4H22l-6 4.4 2.3 7.1-6.3-4.5-6.3 4.5 2.3-7.1-6-4.4h7.6L12 2z" />
        </svg>
      ))}
    </div>
  );
};

const TestimonialCard = ({ testimonial }) => {
  return (
    <div className="testimonial-card" data-aos="fade-up" data-aos-delay={(testimonials.indexOf(testimonial) % 3) * 100}>
      <StarRating rating={testimonial.rating} />
      <p className="testimonial-quote">{testimonial.quote}</p>
      <div className="testimonial-author">
        <div className="author-avatar">
          {testimonial.initials}
        </div>
        <div className="author-info">
          <h4 className="testimonial-author-name">{testimonial.name}</h4>
          <p className="author-role">{testimonial.role}</p>
        </div>
      </div>
    </div>
  );
};

const SuccessStories = () => {


  const studentTestimonials = testimonials.filter(t => t.type === "student");
  const parentTestimonials = testimonials.filter(t => t.type === "parent");

  return (
    <section className="success-stories-section">
      <div className="container">
        <div className="success-stories-header">
          <span className="section-badge">Success Stories</span>
          <h2 className="section-title">Hear From Our Learning Community</h2>
          <p className="section-subtitle">
            Students and parents share their transformative experiences with Chanakya AI
          </p>
        </div>

        <div className="testimonials-columns">
          <div className="testimonial-column student-column">
            <h3 className="column-title">
              🎓 Student Experiences
            </h3>
            <div className="column-testimonials">
              {studentTestimonials.map((testimonial, index) => (
                <TestimonialCard key={index} testimonial={testimonial} />
              ))}
            </div>
          </div>

          <div className="testimonial-column parent-column">
            <h3 className="column-title">
              👨‍👩‍👧‍👦 Parent Perspectives
            </h3>
            <div className="column-testimonials">
              {parentTestimonials.map((testimonial, index) => (
                <TestimonialCard key={index} testimonial={testimonial} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SuccessStories;
